/**
 * Created by carlhaynes on 9/25/17.
 */
import React, { Component } from 'react';
import './Loginx.css';
import { Grid, Row, Col, PageHeader } from 'react-bootstrap';
import {auth, isRealUser} from "../App";
import {withRouter} from 'react-router-dom'

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      error: null
    };

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
  }

  handleEmailChange(event) {
    this.setState({email: event.target.value});
  }
  handlePasswordChange(event) {
    this.setState({password: event.target.value});
  }

  handleSubmit(event) {
    event.preventDefault();

    //console.log('A login was submitted: ' + this.state.email + ' / ' + this.state.password);
    auth.signInWithEmailAndPassword(this.state.email, this.state.password).catch(() => function(error) {
      // Handle Errors here.
     // var errorCode = error.code;
      var errorMessage = error.message;

      console.log("error: " + error.message);
      this.setState({error: errorMessage});
    });

    this.props.history.push('/');

  }

  handleAlertDismiss() {
    this.setState({error: null});
  }

  render() {

    const loginForm = (
        <form type="POST" onSubmit={this.handleSubmit}>
          <div className="formGroup row">
            <Col xs={1}>
                <label htmlFor="emailField" className="col-form-label">
                Email:
                </label>
            </Col>

            <Col xs={11}>
              <input id="emailField" type="email" name='email' value={this.state.email} onChange={this.handleEmailChange} placeholder="Email" />
            </Col>
          </div>

          <div className="Login-formdiv"></div>


          <div className="formGroup row">
            <Col xs={2} md={1}>
              <label htmlFor="emailField" className="col-2 col-form-label">
                Password:
              </label>
            </Col>
            <Col xs={12} md={11}>
              <input id="passwordField" type="password" name='password' value={this.state.password} onChange={this.handlePasswordChange} />
            </Col>
          </div>

          <div className="Login-formdiv"></div>

          <div className="formGroup row">
            <Col smOffset={2}>
              <input className="btn btn-primary" type="submit" value="Submit" />
            </Col>
          </div>

          <div className="Login-formdiv"></div>

        </form>
    );

    return (
      <Grid>
        <Row>
          <PageHeader>Login <small>Please enter your email and password</small></PageHeader>
        </Row>
        <Row>
          {(isRealUser())
            ? 'Already logged in'
            : loginForm
          }
        </Row>
        <Row>
          <a href="/register">No account? Register here</a>
        </Row>

      </Grid>
    );
  }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/pages/Login.jsx